import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("shb_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("shb_token");
  }
}

const saved = localStorage.getItem("shb_token");
if (saved) api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;

export function apiErr(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}

export default api;
